/**
 * The object below is used to keep track of the current pool configuration state
 * 
 * key: Used to later find the object inside the object below
 * title: What is shown in the UI
 * value: The current value for this option
 * reuse: When switching models, should the current value be reused or reset to defaults?
 * 
 */
const poolCustomization = {
    len:        { key: 'len', title: 'Length', value: null, reuse: false, },
    width:      { key: 'width', title: 'Width', value: null, reuse: false, },
    depth:      { key: 'depth', title: 'Depth', value: null, reuse: false, },
    liner:      { key: 'liner', title: 'Liner', value: null, reuse: true, },
    system:     { key: 'system', title: 'Swim System', value: null, reuse: true, },
    coping:     { key: 'coping', title: 'Coping', value: null, reuse: true, },
    skirting:   { key: 'skirting', title: 'Skirting', value: null, reuse: true, },
    shell:      { key: 'shell', title: 'Shell Colors', value: null, reuse: true, },
    location:   { key: 'location', title: 'Location', value: null, reuse: true, },
    install:    { key: 'install', title: 'Install Type', value: null, reuse: true, },
};
export default poolCustomization;